var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPnLogomarkBw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.94 0H0V71.94H71.94V0Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.29 24.18C50.91 24.18 51.44 24.39 51.86 24.81C52.28 25.23 52.49 25.76 52.49 26.38V38.12C52.49 38.71 52.28 39.22 51.86 39.66C51.44 40.1 50.91 40.32 50.29 40.32H20.21V41.2C20.21 41.68 20.52 42.23 21.15 42.85L25.94 47.64C27.04 48.74 27.59 50.05 27.59 51.55C27.59 53.59 25.94 55.24 23.9 55.24H23.28C21.16 55.24 19.43 53.52 19.43 51.39V36V35.73C19.43 33.69 21.08 32.04 23.12 32.04H33.15C34.69 32.04 36.03 32.61 37.17 33.75L42.07 38.71C42.69 39.33 43.25 39.65 43.72 39.65H44.33L44.39 24.94H23.28C21.16 24.94 19.43 23.22 19.43 21.09V20.52C19.43 18.4 21.15 16.67 23.28 16.67H33.1C34.79 16.67 36.15 17.22 37.18 18.32L42.03 23.22C42.65 23.84 43.22 24.16 43.74 24.16H50.3L50.29 24.18Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.94,
    height: 71.94,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnLogomarkBw);
export default __webpack_public_path__ + "static/media/pn_logomark_bw.7f2b8c334c2c55b2610a0f25bb40c1df.svg";
export { ForwardRef as ReactComponent };